import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import OpenPayments from "./components/OpenPayments";  // Keep both
import Skills from "./components/Skills";
import Ring from "./components/Ring.js";
import Analytics from "./components/Analytics";

import Meet from "./components/Meet";

import ChatRoom from "./components/ChatRoom"; 

function App() {
  return (
    <main className="text-gray-400 bg-gray-900 body-font">
      <Navbar />
      <About />
      <Projects />
      <OpenPayments />  {/* Keep both */}
      <Ring />
      <ChatRoom /> 
      <Analytics />
      <Meet />
      
      <Skills />
      
      <Contact />
    </main>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js